/* Elimest sepet upsell: "Ekle" butonu ürünü sepete ekler ve Horizon'un kendi sepet olayıyla
 * çekmeceyi yeniler. Horizon sepeti yeniden çizdiği (morph) için tıklamalar document üzerinden dinlenir. */
import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

// Horizon'un genel Theme nesnesi (window üzerinde değil); yoksa standart Shopify adresleri
const routes = () => (typeof Theme !== 'undefined' && Theme.routes) || { cart_url: '/cart', cart_add_url: '/cart/add' };

function sectionIds() {
  const ids = new Set();
  document.querySelectorAll('cart-items-component').forEach((el) => {
    if (el instanceof HTMLElement && el.dataset.sectionId) ids.add(el.dataset.sectionId);
  });
  return Array.from(ids);
}

async function fetchCart() {
  const cartItems = document.querySelector('cart-items-component');
  if (cartItems) {
    await customElements.whenDefined('cart-items-component');
    // @ts-ignore Horizon bileşen yöntemi
    if (typeof cartItems.fetchCartData === 'function') return cartItems.fetchCartData();
  }
  const res = await fetch(`${routes().cart_url}.json`, { headers: { Accept: 'application/json' } });
  return res.json();
}

document.addEventListener('click', async (event) => {
  const target = /** @type {HTMLElement} */ (event.target);
  const btn = target.closest && target.closest('[data-e-upsell-add]');
  if (!(btn instanceof HTMLButtonElement) || btn.disabled) return;
  event.preventDefault();

  const variantId = btn.dataset.eUpsellAdd;
  btn.disabled = true;
  btn.classList.add('is-loading');

  const deferred = CartLinesUpdateEvent.createPromise();
  btn.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'cart',
      lines: [{ merchandiseId: variantId, quantity: 1 }],
      promise: deferred.promise,
    })
  );

  try {
    const response = await fetch(routes().cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: sectionIds().join(',') }),
    }).then((r) => r.json());

    if (response.status) throw new Error(response.description || response.message || 'Sepete eklenemedi');

    const cart = await fetchCart();
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        itemCount: 1,
        source: 'elimest-upsell',
        sections: response.sections,
        didError: false,
      },
    });
    // Ürün sayfasındaki öneride buton yerinde kalır (çekmecede satır yeniden çizilir): kısa "eklendi" durumu
    const text = btn.querySelector('.e-upsell__add-text');
    const old = text ? text.textContent : '';
    btn.classList.remove('is-loading');
    btn.classList.add('is-added');
    if (text) text.textContent = '✓';
    setTimeout(() => {
      btn.classList.remove('is-added');
      if (text) text.textContent = old;
      btn.disabled = false;
    }, 2000);
  } catch (error) {
    console.error(error);
    deferred.reject(error);
    btn.disabled = false;
    btn.classList.remove('is-loading');
    btn.classList.add('is-error');
    setTimeout(() => btn.classList.remove('is-error'), 1500);
  }
});

/* Kapıda ödeme ile al (ürün sayfası): "Sepete ekle"ye tıklatır; Bundlex paketi ya da temanın kendi formu
 * ürünü nasıl eklerse eklesin, /cart/add isteği başarılı dönünce ödeme sayfasına gider. */
const COD_TIMEOUT = 10000;
let codPending = null;

/* Bekleme sırasında sepet çekmecesi açılmasın: temanın otomatik açmasını kapat, uygulamalar yine açarsa
 * CSS (html.e-cod-pending) çekmeceyi ve uçan ürün animasyonunu gizler; yerine "ödemeye geçiliyor" perdesi çıkar. */
function codHoldDrawer(hold) {
  document.documentElement.classList.toggle('e-cod-pending', hold);
  document.querySelectorAll('cart-drawer-component').forEach((drawer) => {
    if (hold && drawer.hasAttribute('auto-open')) {
      drawer.removeAttribute('auto-open');
      drawer.dataset.eCodAutoOpen = '1';
    } else if (!hold && drawer.dataset.eCodAutoOpen) {
      drawer.setAttribute('auto-open', '');
      delete drawer.dataset.eCodAutoOpen;
    }
  });
}

function codReset() {
  codHoldDrawer(false);
  if (!codPending) return;
  clearTimeout(codPending.timer);
  codPending.btn.disabled = false;
  codPending.btn.classList.remove('is-loading');
  codPending = null;
}

// Ödeme sayfasından geri tuşuyla dönülürse sayfa önbellekten gelir: butonu ve çekmeceyi eski haline getir
window.addEventListener('pageshow', (event) => {
  if (event.persisted) codReset();
});

function codDone(ok) {
  if (!codPending) return;
  if (ok) {
    clearTimeout(codPending.timer);
    window.location.href = `${(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'}checkout`;
  } else {
    codReset();
  }
}

const isCartAdd = (url) => typeof url === 'string' && /\/cart\/add(\.js)?(\?|$)/.test(url.split('#')[0]);

const nativeFetch = window.fetch;
window.fetch = function (input, init) {
  const url = typeof input === 'string' ? input : input && /** @type {Request} */ (input).url;
  const result = nativeFetch.apply(this, arguments);
  if (codPending && isCartAdd(String(url || ''))) {
    result.then((res) => codDone(res.ok)).catch(() => codDone(false));
  }
  return result;
};

const nativeOpen = XMLHttpRequest.prototype.open;
XMLHttpRequest.prototype.open = function (method, url) {
  if (isCartAdd(String(url))) {
    this.addEventListener('loadend', () => {
      if (codPending) codDone(this.status >= 200 && this.status < 300);
    });
  }
  return nativeOpen.apply(this, arguments);
};

document.addEventListener('click', (event) => {
  const target = /** @type {HTMLElement} */ (event.target);
  const btn = target.closest && target.closest('[data-e-cod]');
  if (!(btn instanceof HTMLButtonElement) || btn.disabled || codPending) return;
  event.preventDefault();

  const form = btn.closest('form');
  const addButton = form && form.querySelector('button[name="add"], .add-to-cart-button');
  if (!(addButton instanceof HTMLButtonElement) || addButton.disabled) return;

  btn.disabled = true;
  btn.classList.add('is-loading');
  codPending = { btn, timer: setTimeout(codReset, COD_TIMEOUT) };
  codHoldDrawer(true);
  addButton.click();
});

/* Bundlex paket hediyesi (ör. ErgoPlus'a Uyku Bandı): sepette ürün adedi değişince hediye adedini paket ayarına göre günceller.
 * Kural Bundlex'in kendi paketlerinden okunur (adet eşiği → hediye ekstrası ve adedi); tema kendi kuralını uydurmaz.
 * Bundlex hediyeyi yalnız eşiğin altına düşünce siler, adedini düşürmez ve yeniden eklemez; bu kısım onu tamamlar.
 * Hediye satırı Bundlex'in sepete koyduğu etiketle ({d, o, oid, e}) yeniden eklenir; böylece Bundlex indirimi onu 0 TL sayar.
 * Güvenlik: beklenen yapı yoksa hiçbir şey yapmaz; hediye ücretli kalırsa satırı kaldırır; sorunlar Clarity'ye
 * "elimest_hediye_hata" olayı olarak gider. */
const GIFT_CACHE_KEY = 'e-bx-hediye-v1';
const GIFT_ERROR_EVENT = 'elimest_hediye_hata';
const GIFT_SOURCE = 'elimest-hediye';

function giftReport(reason, error) {
  console.warn('[Elimest hediye]', reason, error || '');
  try {
    if (typeof window.clarity === 'function') {
      window.clarity('set', 'elimest_hediye_neden', reason);
      window.clarity('event', GIFT_ERROR_EVENT);
    }
  } catch (e) {}
}

const gidToId = (gid) => Number(String(gid || '').split('/').pop()) || 0;

/** Bundlex ayarından yalnız hediye kuralları: { [indirimId]: [{ o, oid, threshold, gifts: [{ e, variantId, quantity }] }] } */
function readGiftRules() {
  const el = document.querySelector('.bx-widget-settings');
  if (el instanceof HTMLElement && el.dataset.bxBackendData) {
    try {
      const discounts = JSON.parse(el.dataset.bxBackendData).discounts || [];
      const rules = {};
      discounts.forEach((discount) => {
        const offers = (discount.offers || []).map((offer, index) => ({
          o: index,
          oid: offer.oid,
          threshold: Number(offer.quantity_threshold) || 0,
          gifts: (offer.extras || [])
            .map((extra, e) => ({
              e,
              variantId: gidToId((extra.product_variants || [])[0]),
              quantity: Number(extra.quantity) || 0,
              method: extra.discount_method,
            }))
            .filter((gift) => gift.method === 'gift' && gift.variantId && gift.quantity > 0)
            .map(({ e, variantId, quantity }) => ({ e, variantId, quantity })),
        }));
        if (offers.some((offer) => offer.gifts.length) && offers.every((offer) => offer.threshold > 0)) {
          rules[discount.id] = offers;
        }
      });
      try {
        localStorage.setItem(GIFT_CACHE_KEY, JSON.stringify(rules));
      } catch (e) {}
      return rules;
    } catch (error) {
      giftReport('bundlex-ayar-okunamadi', error);
    }
  }
  // Bundlex ayarı olmayan sayfalarda (ör. ana sayfadaki sepet çekmecesi) son görülen kural
  try {
    return JSON.parse(localStorage.getItem(GIFT_CACHE_KEY) || 'null');
  } catch (e) {
    return null;
  }
}

function parseTag(item) {
  const raw = item.properties && item.properties._bundlex;
  if (!raw) return null;
  try {
    const tag = JSON.parse(raw);
    return tag && typeof tag.d === 'string' ? tag : null;
  } catch (e) {
    return null;
  }
}

/** Sepetteki hediye satırları beklenenden farklıysa yapılacak işler.
 * assumeBundlex: Bundlex bu sayfada çalışıyorsa, sepet satırı değişikliğinden sonra kendi temizliğinde
 * (1) indirimi düşmüş, yani ücretli kalan hediye satırını ve (2) kendi paket eşiği karşılanmayan hediyeyi siler.
 * O satırlara dokunmayız (aynı satıra iki taraf yazınca çakışıyor); kalanları düzeltir, eksiği ekleriz. */
function planGiftChanges(cart, rules, assumeBundlex) {
  const remove = [];
  const add = [];
  const change = [];
  let waitBundlex = false;
  Object.keys(rules).forEach((discountId) => {
    const offers = rules[discountId];
    const thresholdByOid = new Map(offers.map((offer) => [offer.oid, offer.threshold]));
    let mainQuantity = 0;
    const mainByOid = new Map();
    const giftLines = [];
    cart.items.forEach((item) => {
      const tag = parseTag(item);
      if (!tag || tag.d !== discountId) return;
      if (tag.e !== undefined) giftLines.push({ item, tag });
      else if (tag.s === undefined && tag.g === undefined) {
        mainQuantity += item.quantity;
        if (tag.oid !== undefined) mainByOid.set(tag.oid, (mainByOid.get(tag.oid) || 0) + item.quantity);
      }
    });

    let tier = null;
    offers.forEach((offer) => {
      if (offer.threshold <= mainQuantity && (!tier || offer.threshold > tier.threshold)) tier = offer;
    });
    const wanted = tier ? tier.gifts : [];

    // Yalnız bu indirimin hediye ürünlerine dokun (Bundlex'in başka ekstralarına değil)
    const giftVariants = new Set();
    offers.forEach((offer) => offer.gifts.forEach((gift) => giftVariants.add(gift.variantId)));
    const ownLines = giftLines.filter(({ item }) => giftVariants.has(item.variant_id));

    const bundlexRemoves = ({ item, tag }) => {
      if (!assumeBundlex) return false;
      if (item.final_line_price > 0) return true;
      const groupQuantity = mainByOid.get(tag.oid);
      return groupQuantity !== undefined && groupQuantity < (thresholdByOid.get(tag.oid) || 0);
    };
    const survivors = ownLines.filter((line) => !bundlexRemoves(line));
    if (survivors.length !== ownLines.length) waitBundlex = true;

    const matches =
      survivors.length === wanted.length &&
      wanted.every((gift) =>
        survivors.some(
          ({ item, tag }) =>
            item.variant_id === gift.variantId &&
            item.quantity === gift.quantity &&
            item.final_line_price === 0 &&
            tag.o === tier.o &&
            tag.e === gift.e
        )
      );
    if (matches) return;

    // Kalan hediye satırını tek istekte yeni adet + paket etiketine çevir; fazlasını sil, eksiği ekle
    const unused = survivors.slice();
    wanted.forEach((gift) => {
      const properties = { _bundlex: JSON.stringify({ d: discountId, o: tier.o, oid: tier.oid, e: gift.e }) };
      const index = unused.findIndex(({ item }) => item.variant_id === gift.variantId);
      if (index === -1) {
        add.push({ id: gift.variantId, quantity: gift.quantity, properties });
        return;
      }
      const { item, tag } = unused.splice(index, 1)[0];
      if (item.quantity !== gift.quantity || tag.o !== tier.o || tag.e !== gift.e || item.final_line_price !== 0) {
        change.push({ id: item.key, quantity: gift.quantity, properties });
      }
    });
    unused.forEach(({ item }) => remove.push(item.key));
  });
  return { remove, add, change, waitBundlex };
}

async function cartJson() {
  const res = await fetch(`${routes().cart_url}.js`, { headers: { Accept: 'application/json' } });
  if (!res.ok) throw new Error(`cart.js ${res.status}`);
  return res.json();
}

async function postJson(path, body) {
  const res = await fetch(path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.status) throw new Error(`${path} ${res.status} ${data.description || data.message || ''}`);
  return data;
}

/** Sepet çekmecesini / sepet sayfasını Horizon'un kendi olayıyla yeniden çizer */
async function refreshCartUi(sections, knownCart) {
  const cart = knownCart || (await fetchCart());
  const deferred = CartLinesUpdateEvent.createPromise();
  document.dispatchEvent(
    new CartLinesUpdateEvent({ action: 'update', context: 'cart', lines: [], promise: deferred.promise })
  );
  deferred.resolve({
    cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
    detail: { items: cart.items, itemCount: 0, source: GIFT_SOURCE, sections, didError: false },
  });
}

/** Ekrandaki sepet satırları sunucudaki sepetle aynı mı? (Bundlex hediyeyi kendisi silince çekmece eski kalabiliyor) */
function cartUiIsStale(cart) {
  const keys = new Set(cart.items.map((item) => item.key));
  const rows = document.querySelectorAll('cart-items-component tbody tr[data-key]');
  for (const row of rows) {
    if (!(row instanceof HTMLElement)) continue;
    if (!keys.has(row.dataset.key || '') || row.hasAttribute('data-e-gift-pending')) return true;
  }
  return false;
}

// Senkron sürerken ücretli görünen hediye satırında fiyat yerine "Güncelleniyor…" (CSS: html.e-gift-syncing)
let giftSyncingOff = null;
function setGiftSyncing(on) {
  clearTimeout(giftSyncingOff);
  if (on) document.documentElement.classList.add('e-gift-syncing');
  // Kapatırken çekmecenin yeniden çizilmesini bekle (morph olayı çözüldükten sonra gelir)
  else giftSyncingOff = setTimeout(() => document.documentElement.classList.remove('e-gift-syncing'), 500);
}

let giftRunning = false;
let giftAgain = false;
let giftTimer = null;
let giftSafety = null;
let giftVerifyTimer = null;
const giftRuns = [];

/**
 * @param {{ retry?: number, cart?: any, lineChange?: boolean, verify?: boolean }} [options]
 *   cart: temanın az önce döndürdüğü sepet (yeniden okumayı atlar)
 *   lineChange: sepet satırı /cart/change ile değişti; Bundlex şimdi kendi temizliğini yapıyor
 *   verify: Bundlex'in silmesi beklenen satırlar gerçekten gitti mi? Gitmediyse kendimiz düzelt
 */
async function syncGifts(options = {}) {
  const retry = options.retry || 0;
  if (codPending) return setGiftSyncing(false);
  if (giftRunning) {
    giftAgain = true;
    return;
  }
  const rules = readGiftRules();
  if (!rules || !Object.keys(rules).length) return setGiftSyncing(false);

  // Döngü koruması: 20 saniyede 4'ten fazla düzeltme gerekirse dur ve bildir
  const now = Date.now();
  while (giftRuns.length && now - giftRuns[0] > 20000) giftRuns.shift();

  giftRunning = true;
  let wrote = false;
  let keepSyncing = false;
  try {
    const cart = options.cart || (await cartJson());
    const assumeBundlex = !!options.lineChange && !!document.querySelector('.bx-widget-settings');
    const { remove, add, change, waitBundlex } = planGiftChanges(cart, rules, assumeBundlex);
    if (waitBundlex) {
      // Bundlex'in silmesi beklenen satır ekranda "Güncelleniyor…" kalsın; biraz sonra gerçekten silindi mi bak
      keepSyncing = true;
      clearTimeout(giftVerifyTimer);
      giftVerifyTimer = setTimeout(() => queueGiftSync(0, { verify: true }), 2500);
    }
    if (!remove.length && !add.length && !change.length) {
      // Sunucu doğru ama ekran eski olabilir (ör. Bundlex hediyeyi kendisi sildi): ekranı tazele
      if (cartUiIsStale(cart)) await refreshCartUi(null, options.cart ? null : cart);
      return;
    }
    if (giftRuns.length >= 4) {
      giftReport('dongu-durduruldu');
      return;
    }
    giftRuns.push(now);

    const sections = sectionIds().join(',');
    let lastSections = null;
    let after = null;
    wrote = true;
    // Adet ve etiket tek istekte; cevap tüm sepeti verir
    for (const line of change) {
      after = await postJson('/cart/change.js', { ...line, sections });
      lastSections = after.sections;
    }
    if (remove.length) {
      const updates = {};
      remove.forEach((key) => (updates[key] = 0));
      // /cart/update (change değil): Bundlex'in "yetim hediye" temizliğini tetiklemez; cevap tüm sepeti verir
      after = await postJson('/cart/update.js', { updates, sections });
      lastSections = after.sections;
    }
    if (add.length) {
      lastSections = (await postJson('/cart/add.js', { items: add, sections })).sections;
      after = await cartJson();
    }
    // Bundlex eski hediye satırını henüz silmediyse indirim hakkını o kullanıyor olabilir: ücret kontrolü doğrulama turunda
    if ((add.length || change.length) && !waitBundlex) {
      // Bundlex indirimi hediyeyi ücretsiz saymadıysa müşteriye ücretli "hediye" bırakma
      const touched = new Set([...add.map((line) => line.id)]);
      change.forEach((line) => touched.add(Number(String(line.id).split(':')[0])));
      const paid = after.items.filter((item) => {
        const tag = parseTag(item);
        return tag && tag.e !== undefined && touched.has(item.variant_id) && item.final_line_price > 0;
      });
      if (paid.length) {
        const updates = {};
        paid.forEach((item) => (updates[item.key] = 0));
        after = await postJson('/cart/update.js', { updates, sections });
        lastSections = after.sections;
        giftReport('hediye-ucretli-kaldi');
      }
    }
    await refreshCartUi(lastSections, after);
    wrote = false;
  } catch (error) {
    // Bundlex aynı anda kendi temizliğini yapıyor olabilir (satır anahtarı değişir): güncel sepetle hemen yeniden dene
    if (retry >= 2) giftReport('senkron-hatasi', error);
    else giftAgain = { retry: retry + 1 };
  } finally {
    // Yarım kalan bir yazmadan sonra da çekmece eski satır numaralarıyla kalmasın
    if (wrote) await refreshCartUi(null).catch(() => {});
    giftRunning = false;
    if (giftAgain) {
      const next = giftAgain === true ? {} : giftAgain;
      giftAgain = false;
      queueGiftSync(next.retry ? 250 : 0, next);
    } else if (!keepSyncing) {
      setGiftSyncing(false);
    }
  }
}

function queueGiftSync(delay = 0, options = {}) {
  clearTimeout(giftTimer);
  giftTimer = setTimeout(() => syncGifts(options), delay);
  // "Güncelleniyor…" hiçbir durumda takılı kalmasın
  clearTimeout(giftSafety);
  giftSafety = setTimeout(() => {
    if (!giftRunning) setGiftSyncing(false);
  }, delay + 8000);
}

// Sepet her değiştiğinde (tema, Bundlex ya da başka uygulama); kendi yenilememiz hariç
document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  const promise = /** @type {any} */ (event).promise;
  if (!promise) return queueGiftSync();
  setGiftSyncing(true);
  promise.then(
    (result) => {
      const detail = result && result.detail;
      if (detail && detail.source === GIFT_SOURCE) return;
      // Sepet satırı değişikliğinde tema tüm sepeti döndürür: yeniden okumadan hemen başla
      const lineChange = !!detail && detail.source === 'cart-items-component' && Array.isArray(detail.items);
      queueGiftSync(0, lineChange ? { cart: { items: detail.items }, lineChange } : {});
    },
    () => setGiftSyncing(false)
  );
});
// Bundlex hediye sildiğinde bu olayları yayar
['cart:refresh', 'cart:updated'].forEach((name) => document.addEventListener(name, () => queueGiftSync(300)));
// Sepet sayfası açılışında bir kez kontrol
if (/\/cart\/?$/.test(location.pathname)) queueGiftSync(0);
